/**
 * Returns an object with first and last name values
 *
 * @param {string|null|undefined} string
 * @returns {string|null}
 */
const splitFullName = (fullString) => {
  if (!fullString)
    return {
      firstname: null,
      lastname: null
    };
  if (fullString.split(' ').length > 1) {
    return {
      firstname: fullString.substring(0, fullString.lastIndexOf(' ')),
      lastname: fullString.substring(fullString.lastIndexOf(' ') + 1)
    };
  } else {
    return {
      firstname: fullString,
      lastname: null
    };
  }
};

export default splitFullName;
